/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import Icons from '../../icons/IconFileDownload';

const AppNavDownloadButton = props => (
  <div
    className="is-clickable"
    style={Object.assign({ marginLeft: '-18px' }, props.styles)}
    onClick={props.onClick}
  >
    <Icons color={props.color} />
  </div>
);
AppNavDownloadButton.propTypes = {
  color: PropTypes.string,
  styles: PropTypes.any,
  onClick: PropTypes.func,
};

export default AppNavDownloadButton;
